const TOLERANCE = 0.000001;

export default function(a, b) {
  return Math.abs(a - b) < TOLERANCE;
}
